import { Modal } from "takeat-design-system-ui-kit";
import styled from "styled-components";

export const WaiterHelpModalContainer = styled(Modal)`
  width: fit-content;
  height: fit-content;
  padding: 16px;
  > div {
    width: 438px;
    > header {
      display: flex;
      flex-direction: row;
      gap: 16px;
      margin-bottom: 16px;
  
      > div {
        display: flex;
        flex-direction: column;
        gap: 8px;
  
        > p {
          color: var(--Takeat-Colors-Neutrals-Black-01, #222);
          font-family: Poppins;
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: var(--Headline-Small-Tracking, 0);
          padding: 0;
          margin: 0;
        } 
  
        > span {
          color: var(--Takeat-Colors-Neutrals-Grey-01, #545454);
          font-family: Poppins;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          letter-spacing: 0.1px;
          padding: 0;
          margin: 0;
        }
      }
    }
  
    > main {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-bottom: 8px;
  
      > div {
        > span {
          color: var(--Takeat-Colors-Neutrals-Black-01, #222);
          font-family: Poppins;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          letter-spacing: 0.1px;
        }
  
      }
    }
  
    > footer {
      border-top: 1px solid #EDEDED;
      padding-top: 12px;
    }
  }
`

export const WaiterHelpModalItems = styled.div`
  border-radius: 12px;
  background: var(--Takeat-Colors-Neutrals-Grey-05, #F6F6F6);
  padding: 12px;
  display: flex;
  flex-direction: column;
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-self: center;
  align-items: center;
`

export const WaiterHelpItemNumber = styled.div`
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid var(--Takeat-Colors-Neutrals-Grey-03, #C6C6C6);
  background: var(--Takeat-Colors-Neutrals-White, #FFF);
  color: var(--Takeat-Colors-Neutrals-Grey-01, #545454);
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.1px;
  align-content: center;
  margin-right: 8px;
`

export const WaiterHelpPoint = styled.section`
  width: 6px;
  height: 6px;
  border-radius: 6px;
  background-color: #222222;
  margin: 0 20px 0 16px;
`

export const WaiterHelpModalItemsTotal = styled.div`
  background: var(--Takeat-Colors-Neutrals-Grey-05, #F6F6F6);
  flex-direction: column;
  display: flex;
  border-radius: 12px;
  margin-top: 8px;
  padding: 12px;
  gap: 8px;
  > div {
    display: flex;
    flex-direction: row;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.1px;
    align-content: center;
    align-items: center;
  }
`